import React from 'react';
import { useTheme } from '../../../context/ThemeContext';

interface PaymentResultModalProps {
  isOpen: boolean;
  isSuccess: boolean;
  isLoading: boolean;
  message: string;
  onClose: () => void;
}

const PaymentResultModal: React.FC<PaymentResultModalProps> = ({ isOpen, isSuccess, isLoading, message, onClose }) => {
  const { theme } = useTheme();

  if (!isOpen) return null;
  
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg p-4 sm:p-8 shadow-lg text-center w-[95%] max-w-sm mx-auto">
        {isLoading ? (
          <>
            <div className="flex justify-center mb-3 sm:mb-4">
              <svg className={`animate-spin h-8 w-8 ${theme['home-button-text']}`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
              </svg>
            </div>
            <h2 className={`text-lg sm:text-xl font-bold mb-2 ${theme['home-button-text']}`}>Please Wait...</h2>
            <p className="mb-4 sm:mb-6 text-sm sm:text-base">Please wait while we process your payment.</p>
          </>
        ) : (
          <>
            <h2 data-testid="payment-result-modal-title" className={`text-xl sm:text-2xl font-bold mb-3 sm:mb-4 ${isSuccess ? 'text-green-600' : 'text-red-600'}`}>
              {isSuccess ? 'Payment Successful' : 'Payment Failed'}
            </h2>
            <p className="mb-4 sm:mb-6 text-sm sm:text-base">{message}</p>
            <button
              data-testid="close-button"
              className="w-full sm:w-auto px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 text-sm sm:text-base"
              onClick={onClose}
            >
              Close
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentResultModal; 